module.exports = __webpack_public_path__ + "img/banner.b4b8bd51.png";